import React from 'react'

const Header = () => {
  return (
    <section id="showcase">
      <div className="showcase-content">
        <h1 className="l-heading">Restore Natural Beauty</h1>
        <p className="lead">
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Architecto at nostrum voluptas officia? Exercitationem, eligendi.
        </p>
        <a href="#contact-us" className="btn">Request a Quote</a>
      </div>
    </section>
  )
}

export default Header